import { cartCacheHandlerFactory } from '../helpers/cartCacheHandler';

export async function afterRegistration ({ Vue, config, store, isServer }) {
  store.subscribe(cartCacheHandlerFactory(Vue))
}
